import { FormattedMessage, injectIntl } from 'react-intl';
import React, { useState, useContext, useEffect, useRef } from 'react';
import { Modal, Form, Input, Row, Col, Button, Tooltip } from 'antd';
import myContext from '@/utils/createContext';
import { InfoCircleOutlined, UserOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { gtag } from '@/utils'
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import allRegex from '@/components/allRegex.js';

function ExchangeRate(props) {
  const intl = props.intl;
  const { formatMessage } = intl;
	const { form, cashierData, showDomain, getExchangeRateData } = useContext(myContext);
	console.log(cashierData);
	const { ablePaymentCurrencyList } = cashierData;

  const [paymentCurrencyList, setPaymentCurrencyList] = useState(ablePaymentCurrencyList[0] || []);


  const paymentCurrencyHtml = (paymentCurrencyList.targetCurrency || '') + ' ' + (paymentCurrencyList.amount || '') + ' ' + (paymentCurrencyList.targetCurrencyName || '');
//   const onBlurChoosePaymentCurrency = async function(e) {
//     gtag(`${showDomain}支付页面`, [new Date() + '输入邮箱']);
//     gtag(`${showDomain}支付页面`, ['输入邮箱']);
//     showDomain ? gtag(`定制支付页面`, ['输入邮箱']):'';
//   };

  const getDiffCurrencyAmount = e => {
	  let data = JSON.parse(e.target.value);
	  setPaymentCurrencyList(data);
	  getExchangeRateData(data);
	  console.log(data.targetCurrencyDesc);
	  gtag(`${showDomain}支付页面`, [new Date() + '选择汇率' + data.targetCurrencyDesc]);
	  gtag(`${showDomain}支付页面`, ['选择汇率']);
	  showDomain ? gtag(`定制支付页面`, ['选择汇率']):'';
  }

  return (
    <div className="h5-exchange-rate">
	  <Row gutter={20} className="h5pc-address-mb10">
			<Col span={24}>
				<span className="h5_currency">
                  {formatMessage({ id: 'ga-checkout.currency' })}
                </span>
				<FloatLabel
					form={form}
					name="exchange-rate"
					floatclassname="h5-label-float"
					// cref={emailRef}
					label={formatMessage({
						id: 'ga-checkout.choose-payment-currency',
					})}
				>
					<select size="large" maxLength={64} className="my-native-select" onChange={getDiffCurrencyAmount}>
						{ablePaymentCurrencyList.map((v, k) => {
							return (
							<option value={JSON.stringify(v)} key={v.changeRate}>
								{ v.targetCurrencyName || '' }(1 {v.sourceCurrencyName} = {v.changeRate} {v.targetCurrencyName})
							</option>
							);
						})}
					</select>
				</FloatLabel>
			</Col>
		  </Row>
		<Row gutter={20} className="h5pc-address-mb10">
			<Col span={24}>
				<FloatLabel
					form={form}
					floatclassname="h5-label-float"
					// cref={emailRef}
					label={formatMessage({
						id: 'ga-checkout.payment-amount',
					})}
				>
					<Input 
						size="large" 
						maxLength={64} 
						className="exchange-rate-amount" 
						disabled 
						style={{ paddingRight: '40px' }} 
						value={paymentCurrencyHtml} 
					/>
				</FloatLabel>
				
			</Col>
		</Row>
		{/* <Row gutter={20} className="h5pc-address-mb10">
			<Col span={24}>
				<div className='exchange-rate-line'></div>
			</Col>
		</Row> */}
    </div>
  );
}

export default injectIntl(ExchangeRate);
